export const locales = {
	label: 'AM/FINESS :',
	defaultStructure: 'Par défaut'
};
